import type { ElementType, ReactNode } from 'react'

import { useReveal } from '@/lib/useReveal'

interface Props {
  children: ReactNode
  /** Stagger index — CSS turns this into `transition-delay: calc(var(--i) * 80ms)`. */
  i?: number
  className?: string
  as?: ElementType
  threshold?: number
}

export function Reveal({ children, i = 0, className = '', as, threshold }: Props) {
  const Tag = (as ?? 'div') as ElementType
  const { ref, inView } = useReveal<HTMLDivElement>(
    threshold === undefined ? {} : { threshold, rootMargin: '0px' },
  )

  return (
    <Tag
      ref={ref}
      data-in={inView}
      className={`reveal ${className}`.trim()}
      style={{ ['--i' as string]: i }}
    >
      {children}
    </Tag>
  )
}
